import React, {PropTypes} from 'react';
import {Link} from 'react-router-dom';
import {Table, TableHeader, TableRow, TableCell} from 'pui-react-table';

export default class ClientActionsCell extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    const linkTo = "/accountants/clients/" + this.props.value;

    return (
      <TableCell className="client-actions-cell">
        <Link to={linkTo}>View Client</Link>
      </TableCell>
    );
  }
}



// WEBPACK FOOTER //
// ./src/accountants/ClientActionsCell.js